@if ((this.client$ | async) && (this.intermediary$ | async)) {
  <snelstart-ui-details [config]="detailsConfig">
    <snelstart-ui-details-title>
      @if ((this.client$ | async)?.sstRelationId === clientId) {
        <div style="font-size: 18px">
          <strong>{{ (this.client$ | async)?.name }}</strong>
        </div>
      }
    </snelstart-ui-details-title>

    <snelstart-ui-details-buttons>
      <snelstart-ui-button (click)="this.showDialogClientSettings()"
                           [disabled]="(this.client$ | async)?.sstRelationId !== clientId"
                           icon="gear"
                           type="primary">Klantinstellingen
      </snelstart-ui-button>
    </snelstart-ui-details-buttons>

    @if ((this.client$ | async)?.sstRelationId === clientId) {
      <snelstart-ui-details-content>
        <div class="row d-flex">
          <div class="col">
            <snelstart-ui-card>
              <div class="card-header">
                SnelStart klantadministratie
              </div>
              <div class="card-body">
                @if (!(this.client$ | async)?.adminEntities?.length) {
                  <p>Koppel een SnelStart-administratie om deze module te activeren.</p>
                } @else {
                  <p>Openen klantadministratie in Snelstart Polaris.</p>
                }
              </div>
              <snelstart-ui-button (click)="this.openTaxAppInNewTab('admin')"
                                   [disabled]="!(this.client$ | async)?.adminEntities?.length"
                                   [type]="!(this.client$ | async)?.adminEntities?.length ? 'secondary' : 'primary'"
                                   class="card-button"
                                   iconRight="arrow-up-right-from-square"
              >Administratie
              </snelstart-ui-button>
            </snelstart-ui-card>
          </div>
          <div class=col>
            <snelstart-ui-card>
              @if ((this.client$ | async)?.corporateTax) {
                <div class="card-header">
                  Vennootschapsbelasting
                </div>
              } @else if ((this.client$ | async)?.incomeTax) {
                <div class="card-header">
                  Inkomstenbelasting
                </div>
              } @else {
                <div class="card-header">
                  Inkomstenbelasting of vennootschapsbelasting
                </div>
              }
              <div class="card-body">
                @if ((this.client$ | async)?.incomeTax && (this.client$ | async)?.taxId && !!customerResponse.fiscalIdentifier?.trim()) {
                  <p>Indienen aangiften en voorlopige aanslagen inkomstenbelasting
                  </p>
                } @else if ((this.client$ | async)?.corporateTax && (this.client$ | async)?.taxId) {
                  <p>Indienen aangiften en voorlopige aanslagen vennootschapsbelasting .</p>
                } @else if ((this.client$ | async)?.taxId == null) {
                  <p>Stel belastingplicht en fiscaal nummer in om de module te activeren.</p>
                } @else {
                  <p>Stel belastingplicht en fiscaal nummer in om de module te activeren.</p>
                }
              </div>
              <div>
                @if ((this.client$ | async)?.incomeTax) {
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-income')"
                                       [disabled]="!(this.client$ | async)?.incomeTax || (this.client$ | async)?.taxId == null"
                                       [type]="(!(this.client$ | async)?.incomeTax || (this.client$ | async)?.taxId == null) ? 'secondary' : 'primary'"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"

                  >Inkomstenbelasting
                  </snelstart-ui-button>
                } @else if ((this.client$ | async)?.corporateTax) {
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-corporate')"
                                       [disabled]="!(this.client$ | async)?.corporateTax || (this.client$ | async)?.taxId == null"
                                       [type]="(!(this.client$ | async)?.corporateTax || (this.client$ | async)?.taxId == null) ? 'secondary' : 'primary'"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"
                  >Vennootschapsbelasting
                  </snelstart-ui-button>
                } @else {
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-corporate')"
                                       [disabled]="true"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"
                                       type="secondary"
                  >Module (nog) niet geactiveerd
                  </snelstart-ui-button>
                }
              </div>
            </snelstart-ui-card>
          </div>
        </div>
        <div class="row d-flex pt-3">
          <div class=col>
            <snelstart-ui-card>
              <div class="card-header">
                Omzetbelasting
              </div>
              <div class="card-body">
                @if (!(this.client$ | async)?.valueAddedTax) {
                  <p>Stel belastingplicht omzetbelasting in om de module te activeren.</p>
                } @else {
                  <p>Aangiften omzetbelasting en opgaves ICP (ook zonder SnelStart Administratie).</p>
                }
              </div>
              <div>
                <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-vat')"
                                     [disabled]="!(this.client$ | async)?.valueAddedTax"
                                     [type]="!(this.client$ | async)?.valueAddedTax ? 'secondary' : 'primary'"
                                     class="card-button"
                                     iconRight="arrow-up-right-from-square"
                                     type="secondary"
                >Omzetbelasting
                </snelstart-ui-button>
              </div>
            </snelstart-ui-card>
          </div>
          <div class=col>
            <snelstart-ui-card>
              <div class="card-header">
                <snelstart-ui-badge type="success" label="Accountant Pro" />
                Jaarrapportage
              </div>
              <div class="card-body">
                @if ((this.intermediary$ | async)?.licenceName === 'Accountant Pro') {
                  @if (!(this.client$ | async)?.sbiCode || !(this.client$ | async)?.kvkId || !(this.client$ | async)?.classificatie) {
                    <p>Vul KVK-nummer, SBI-code en bedrijfsklasse in om de module te activeren.</p>
                  } @else {
                    <p>Jaarrapportages genereren voor rechtspersonen
                      en natuurlijke personen en publiceren voor micro en kleine rechtspersonen.</p>
                  }
                } @else {
                  <p>Onderdeel van de SnelStart Accountant Pro licentie.
                    Contact onze klantenservice voor een proefperiode.</p>
                }
              </div>
              <div>
                <snelstart-ui-button (click)="this.openTaxAppInNewTab('pm-report')"
                                     [disabled]="(this.intermediary$ | async)?.licenceName !== 'Accountant Pro' || !(this.client$ | async)?.kvkId || !(this.client$ | async)?.sbiCode || !(this.client$ | async)?.classificatie"
                                     [type]="((this.intermediary$ | async)?.licenceName !== 'Accountant Pro' || !(this.client$ | async)?.kvkId || !(this.client$ | async)?.sbiCode || !(this.client$ | async)?.classificatie) ? 'secondary' : 'primary'"
                                     class="card-button"
                                     iconRight="arrow-up-right-from-square"
                                     type="secondary"
                >Jaarrapportage
                </snelstart-ui-button>
              </div>
            </snelstart-ui-card>
          </div>
        </div>

        @if ((this.client$ | async)?.incomeTax) {
          <div class="row d-flex pt-3">
            <div class=col>
              <snelstart-ui-card>
                <div class="card-header">
                  Toeslagen
                </div>
                <div class="card-body">
                  <p>Aanvragen, wijzigen en stopzetten van toeslagen.</p>
                </div>
                <div>
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-allowance')"
                                       [type]="(!(this.client$ | async)?.incomeTax || (this.client$ | async)?.taxId == null) ? 'secondary' : 'primary'"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"
                  >Toeslagen
                  </snelstart-ui-button>
                </div>
              </snelstart-ui-card>
            </div>
            <div class=col>
              <snelstart-ui-card>
                <div class="card-header">
                  <snelstart-ui-badge type="success" label="Accountant Pro" />
                  Erfbelasting
                </div>
                <div class="card-body">
                  <p>Module is nog niet beschikbaar (verwacht 3e kwartaal 2026).</p>
                </div>
                <div>
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-bezwaar')"
                                       [disabled]="true"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"
                                       type="secondary"
                  >Erfbelasting
                  </snelstart-ui-button>
                </div>
              </snelstart-ui-card>
            </div>
          </div>
        }

        <div class="row d-flex pt-3">
          <div class=col>
            <snelstart-ui-card>
              <div class="card-header">
                <snelstart-ui-badge type="success" label="Accountant Pro" />
                Salarisadministratie
              </div>
              <div class="card-body">
                @if ((this.intermediary$ | async)?.licenceName === 'Accountant Pro') {
                  @if ((this.client$ | async)?.wageTax) {
                    <p>Salarisadministratie voor DGA's en
                      werknemers zonder CAO/pensioenregeling.</p>
                  } @else {
                    <p>Stel inhoudingsplicht loonheffingen in om de module te activeren.</p>
                  }
                } @else {
                  <p>Onderdeel van de SnelStart Accountant Pro licentie.
                    Contact onze klantenservice voor een proefperiode.</p>
                }
              </div>
              <div>
                <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-wage')"
                                     [disabled]="(this.intermediary$ | async)?.licenceName !== 'Accountant Pro' || !(this.client$ | async)?.wageTax"
                                     [type]="((this.intermediary$ | async)?.licenceName !== 'Accountant Pro' || !(this.client$ | async)?.wageTax) ? 'secondary' : 'primary'"
                                     class="card-button"
                                     iconRight="arrow-up-right-from-square"
                >Salarisadministratie
                </snelstart-ui-button>
              </div>
            </snelstart-ui-card>
          </div>
          <div class=col>
            <snelstart-ui-card>
              <div class="card-header">
                <snelstart-ui-badge type="success" label="Accountant Pro" />
                @if ((this.client$ | async)?.corporateTax) {
                  Dividendbelasting
                } @else if ((this.client$ | async)?.incomeTax) {
                  Schenkbelasting
                } @else {
                  Dividend- of schenkbelasting
                }
              </div>
              <div class="card-body">
                @if ((this.intermediary$ | async)?.licenceName === 'Accountant Pro') {
                  @if ((this.client$ | async)?.incomeTax) {
                    <p>Aangiften schenkbelasting opstellen en indienen.</p>
                  } @else if ((this.client$ | async)?.corporateTax) {
                    <p>Aangiften dividendbelasting opstellen en indienen.</p>
                  } @else {
                    <p>Stel belastingplicht ib/vpb in om deze modules te activeren.</p>
                  }
                } @else {
                  <p>Onderdeel van de SnelStart Accountant Pro licentie.
                    Contact onze klantenservice voor een proefperiode.</p>
                }
              </div>
              <div>
                @if ((this.client$ | async)?.incomeTax) {
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-donation')"
                                       [disabled]="(this.intermediary$ | async)?.licenceName !== 'Accountant Pro' || !(this.client$ | async)?.incomeTax"
                                       [type]="(!(this.client$ | async)?.incomeTax || (this.client$ | async)?.taxId == null) ? 'secondary' : 'primary'"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"

                  >Schenkbelasting
                  </snelstart-ui-button>
                } @else if ((this.client$ | async)?.corporateTax) {
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-dividend')"
                                       [disabled]="(this.intermediary$ | async)?.licenceName !== 'Accountant Pro' || !(this.client$ | async)?.corporateTax || !(this.intermediary$ | async)?.beconId"
                                       [type]="(!(this.client$ | async)?.corporateTax) ? 'secondary' : 'primary'"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"
                  >Dividendbelasting
                  </snelstart-ui-button>
                } @else {
                  <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-dividend')"
                                       [disabled]="true"
                                       class="card-button"
                                       iconRight="arrow-up-right-from-square"
                                       type="secondary"
                  >Module (nog) niet geactiveerd
                  </snelstart-ui-button>
                }
              </div>
            </snelstart-ui-card>
          </div>
        </div>
        <div class="row d-flex pt-3">
          <div class=col>
            <snelstart-ui-card>
              <div class="card-header">
                Online bezwaar
              </div>
              <div class="card-body">
                @if ((this.intermediary$ | async)?.certValidUntil == null) {
                  <p>Upload een PKI-certificaat in via de kantoorinstellingen om de module te
                    activeren.</p>
                } @else {
                  <p>Online bezwaar tegen beschikkingen ib/vpb/btw van de Belastingdienst.</p>
                }
              </div>
              <div>
                <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-bezwaar')"
                                     [disabled]="((this.intermediary$ | async)?.certValidUntil == null || (this.client$ | async)?.taxId == null)"
                                     [type]="((this.intermediary$ | async)?.certValidUntil == null || (this.client$ | async)?.taxId == null) ? 'secondary' : 'primary'"
                                     class="card-button"
                                     iconRight="arrow-up-right-from-square"
                >Online bezwaar
                </snelstart-ui-button>
              </div>
            </snelstart-ui-card>
          </div>
          <div class=col>
            <snelstart-ui-card>
              <div class="card-header">
                Machtigingen
              </div>
              <div class="card-body">
                @if ((this.intermediary$ | async)?.certValidUntil == null) {
                  <p>Upload een PKI-certificaat in via de kantoorinstellingen om de module te
                    activeren.</p>
                } @else {
                  <p>Beheer machtigingen voor ontvangen serviceberichten Belastingdienst.</p>
                }
              </div>
              <div>
                <snelstart-ui-button (click)="this.openTaxAppInNewTab('tax-muma')"
                                     [disabled]="((this.intermediary$ | async)?.certValidUntil == null || (this.client$ | async)?.taxId == null)"
                                     [type]="((this.intermediary$ | async)?.certValidUntil == null || (this.client$ | async)?.taxId == null) ? 'secondary' : 'primary'"
                                     class="card-button"
                                     iconRight="arrow-up-right-from-square"
                >Machtigingen
                </snelstart-ui-button>
              </div>
            </snelstart-ui-card>
          </div>
        </div>
      </snelstart-ui-details-content>
    }
  </snelstart-ui-details>
} @else {
  <snelstart-ui-details-content>
    <snelstart-ui-spinner size="medium" />
  </snelstart-ui-details-content>
}

<snelstart-venture-fiscaal-domain-logic-client [(dialogVisible)]="dialogClientSettingsVisible"
                                               [customer]="customerResponse">
</snelstart-venture-fiscaal-domain-logic-client>
